export const relatedGuestDealersAlertDismissedCookieName =
  'relatedGuestDealersAlertDismissed'
